<template>
  <v-container fluid>
    <loader :show="$isLoading()" message="Cargando patrocinios..."></loader>
    <confirm-modal
      :dialog="showConfirm"
      message="¿Estás seguro de eliminar este patrocinio?"
      @confirm="confirmResponse"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h3 class="green--text headline mb-0">Patrocinios</h3>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            dark
            color="green"
            slot="activator"
            fab
            small
            @click="goNewSponsorship">
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nuevo Patrocinio</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
        <v-flex xs12 md10 offset-md1>
            <v-text-field
            box
            name="searchbar"
            label="Buscar Patrocinios"
            append-icon="search"
            color="green"
            v-model="filter"></v-text-field>
        </v-flex>
        <v-flex xs12 md10 offset-md1>
            <v-data-table
                :rows-per-page-items="[ 25, 50, 100 ]"
                :headers="headers"
                :items="currentSponsorships"
                :search="filter"
                class="elevation-1"
                light
                rows-per-page-text="Filas por página">
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left green--text"
                        @click="goEditSponsorship( props.item.id )">
                        <span class="cursor-pointer">{{ props.item.name_es }}</span>
                    </td>
                    <td class="text-xs-right">{{ props.item.title_es }}</td>
                    <td class="text-xs-right">{{ props.item.description_es }}</td>
                    <td class="text-xs-right">{{ props.item.sections.length }}</td>
                    <td class="text-xs-right">{{ props.item.date_from }}</td>
                    <td class="text-xs-right">{{ props.item.date_to }}</td>
                    <td class="text-xs-left">
                        <v-tooltip left>
                            <v-btn
                                flat
                                icon
                                light
                                @click="showConfirm = true; selectedId = props.item.id"
                                slot="activator">
                                <v-icon>delete</v-icon>
                            </v-btn>
                            <span>Eliminar Patrocinio</span>
                        </v-tooltip>
                    </td>
                    <td class="text-xs-left">
                        <v-tooltip left>
                            <v-btn
                                flat
                                icon
                                light
                                @click="goEditSponsorship( props.item.id )"
                                slot="activator">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <span>Editar Patrocinio</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'Sponsorchips',
        data: () => ({
            selectedId: null,
            showConfirm: false,
            loader: false,
            filter: '',
            headers: [
                { text: 'Nombre', value: 'name_es', align: 'left' },
                { text: 'Titulo', value: 'title_es', align: 'left' },
                { text: 'Descripción', value: 'description_es', align: 'left' },
                { text: 'Secciones', value: 'sections', align: 'left' },
                { text: 'Fecha de inicio', value: 'date_from', align: 'left' },
                { text: 'Fecha de fin', value: 'date_to', align: 'left' },
                { text: '', value: 'delete', align: 'left' }
            ]
        }),
        created() {
            
            this.loader = true;
            this.loadSponsorships({
                callback: response => {
                    this.loader = false;
                    console.log(this.currentSponsorships);
                },
                errorCallback: e => {
                    this.loader = false;
                    console.error(e);
                }
            });
        },
        computed: {
            ...mapGetters([
                'currentSponsorships',
            ]),
            ...mapGetters('loading', [
                'isLoading',
                'anyLoading',
            ])
        },
        methods: {
            ...mapActions([
                'loadSponsorships',
                'goNewSponsorship',
                'deleteSponsorship',
                'goEditSponsorship'
            ]),
            confirmResponse( e ) {
                
                this.showConfirm = false;
                this.deleteSponsorship( this.selectedId );
                this.selectedId = null;
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/pages/sponsorships/sponsorships.vue